export const CURRENCY_IDS = Object.freeze({
  USD: 1,
  LBP: 2,
});

export const S2S_PRESET_AMOUNTS = Object.freeze({
  [CURRENCY_IDS.USD]: [1000, 5000, 10000],
  [CURRENCY_IDS.LBP]: [1000000, 10000000, 100000000],
});
